import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TenantContext } from 'shared/contexts';
import { LoadingStatus } from 'shared/types';

import { statusSelector } from '../store';

export function usePageStatus(): LoadingStatus {
    const offersFetchStatus = useSelector(statusSelector);
    const { status: tenantFetchStatus } = useContext(TenantContext);

    return useMemo(() => {
        if (tenantFetchStatus === 'success' && offersFetchStatus === 'success') {
            return 'success';
        }

        if (tenantFetchStatus === 'error' || offersFetchStatus === 'error') {
            return 'error';
        }

        return 'pending';
    }, [ offersFetchStatus, tenantFetchStatus ]);
}
